import { FieldHeader } from '@models/companies';

export function resolveFieldHeader(fieldHeaders: FieldHeader[], field: string): string | undefined {
  return fieldHeaders.find((header) => header.FieldName === field)?.Header;
}
